import type { ApiConfig } from '../../types'

export const perpsTradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'perps-trade-history',
} as const satisfies ApiConfig
